import apiClient from "@/config/api";

const RESOURCE = "/rental-vehicles";

export default {
  async list({ commit, rootState }, pagination = 1) {
    const page = typeof pagination === "number" ? pagination : pagination.page || 1;
    const perPage = typeof pagination === "number" ? 10 : pagination.per_page || 10;
    const all = pagination.all === true && Number(rootState.auth.user?.role) === 1 ? "&all=true" : "";
    const response = await apiClient.get(`${RESOURCE}?page=${page}&per_page=${perPage}${all}`);
    commit("SET_DATA", response.data.data);
    return response.data.data;
  },
  async options({ commit }) {
    const response = await apiClient.get(`${RESOURCE}/options`);
    commit("SET_OPTIONS", response.data.data);
    return response.data.data;
  },
  async show(_context, slug) {
    const response = await apiClient.get(`${RESOURCE}/slug/${slug}`);
    return response.data.data;
  },
  async store(_context, formData) {
    const response = await apiClient.post(RESOURCE, formData);
    return response.data.data;
  },
  async update(_context, { slug, formData }) {
    formData.set("_method", "PUT");
    const response = await apiClient.post(`${RESOURCE}/slug/${slug}`, formData);
    return response.data.data;
  },
  async publish(_context, id) {
    const response = await apiClient.post(`${RESOURCE}/${id}/publish`);
    return response.data.data;
  },
  async deactivate(_context, id) {
    const response = await apiClient.post(`${RESOURCE}/${id}/deactivate`);
    return response.data.data;
  },
  async destroy(_context, slug) {
    const response = await apiClient.delete(`${RESOURCE}/slug/${slug}`);
    return response.data;
  },
};
